import EditorCodePane from './EditorCodePane';

export default EditorCodePane;
